// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"74151d0d","677":"3a0ce8b9"}[chunkId] + ".chunk.js";
};